/* ============================================================
   Nachbestellungs-Rechner – Staffelpreis-Logik. Kein Geraet, nur
   Testkits + Lanzetten.

   B-07: Schwellen (DATA.tierBoxes5/10) und Prozentsaetze
   (DATA.tierRate5/10) kommen aus window.gcReorderData, das die
   Section aus den globalen Theme-Einstellungen
   ("Mengenrabatt-Schwellen") befuellt – nicht mehr hier hart codiert.

   Aposanitas-Modus (06.10.2026): ist DATA.apo.active, gilt statt der
   normalen Staffel EINE Stufe ab DATA.apo.minBoxes Testboxen mit
   DATA.apo.rate % (15 % bis 31.10., danach 10 %) - dieselbe
   Testbox-Staffel wie im Aposanitas-Neukundenrechner. Die Codes setzt
   assets/gc-aposanitas.js im Warenkorb.

   W-14 (wieder aufgenommen 10.09.2026): die Lanzetten-Automatik ist
   jetzt aktiv, nach demselben Muster wie im Starterkit-Rechner.
   autoSuggestLancets() und requiredLancetBoxes() waren vorher
   definiert, wurden aber nie aufgerufen – die Lanzettenzahl blieb
   immer auf 0, bis jemand von Hand am Stepper drehte.

   Rechenweg: Summe der benoetigten Einzeltests geteilt durch die
   Stueckzahl pro Lanzettenbox, aufgerundet. Tests mit
   lancetsIncluded (Feld "Lanzetten bereits im Testkit enthalten"
   am Block) zaehlen NICHT mit.

   Sobald jemand den Lanzetten-Stepper selbst benutzt, greift
   lancetManuallySet und die Automatik haelt sich raus – sonst
   wuerde sie die Eingabe beim naechsten Klick ueberschreiben.
   ============================================================ */
(function(){
  const root = document.getElementById('gcr-reorder-root');
  if(!root) return;

  const DATA = window.gcReorderData;
  const APO = (DATA.apo && DATA.apo.active) ? DATA.apo : null;
  let quantities = {};
  DATA.tests.forEach(t => quantities[t.key] = 0);
  quantities['lancet'] = 0;
  let lancetManuallySet = false;

  function fmt(n){
    return Number(n).toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
  }

  function buildRows(){
    const container = document.getElementById('gcr-test-rows');
    container.innerHTML = '';
    DATA.tests.forEach(t => {
      const row = document.createElement('div');
      row.className = 'cfg-row';
      row.id = 'gcr-row-' + t.key;
      const infoIcon = '<svg class="cfg-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v5" stroke-linecap="round"/><circle cx="12" cy="8" r="0.6" fill="currentColor" stroke="none"/></svg>';
      const infoLink = t.url
        ? `<a class="cfg-link cfg-link-preview" href="${t.url}" data-test-key="${t.key}">${infoIcon}Informationen</a>`
        : '';
      row.innerHTML = `
        <div class="cfg-info">
          <div class="cfg-label-row">
            <span class="cfg-label">${t.label}</span>
            ${infoLink}
          </div>
          <div class="cfg-meta">${t.perBox} Stk./Box</div>
          ${t.deviceNote ? `<div class="lancet-warning show" style="color:var(--muted);">${t.deviceNote}</div>` : ''}
        </div>
        <div class="cfg-right">
          <span class="cfg-total zero" id="gcr-total-${t.key}">${fmt(t.price)}</span>
          <div class="qty-ctrl">
            <button class="qty-btn" data-key="${t.key}" data-delta="-1" type="button" aria-label="Eine Box weniger">−</button>
            <span class="qty-num" id="gcr-qty-${t.key}">0</span>
            <button class="qty-btn" data-key="${t.key}" data-delta="1" type="button" aria-label="Eine Box mehr">+</button>
          </div>
        </div>`;
      container.appendChild(row);
    });
    container.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => adj(btn.dataset.key, parseInt(btn.dataset.delta, 10)));
    });
    container.querySelectorAll('.cfg-link-preview').forEach(link => {
      const t = DATA.tests.find(x => x.key === link.dataset.testKey);
      if(!t) return;
      link.addEventListener('mouseenter', (e) => gcRenderPreview(e, {
        title: t.label,
        price: '€ ' + Number(t.price).toLocaleString('de-DE', {minimumFractionDigits:2}),
        desc: t.desc || '',
        image: t.image || ''
      }));
      link.addEventListener('mouseleave', () => gcHidePreview());
    });
  }

  function adj(key, delta){
    quantities[key] = Math.max(0, quantities[key] + delta);
    document.getElementById('gcr-qty-' + key).textContent = quantities[key];
    const t = DATA.tests.find(x => x.key === key);
    const totalEl = document.getElementById('gcr-total-' + key);
    const qty = quantities[key];
    if(qty > 0){
      totalEl.textContent = fmt(t.price * qty);
      totalEl.classList.remove('zero');
    } else {
      totalEl.textContent = fmt(t.price);
      totalEl.classList.add('zero');
    }
    autoSuggestLancets();
    updateAll();
  }

  /* Tests, bei denen die Lanzetten schon im Kit liegen, zaehlen nicht mit
     (Feld lancets_included am Block). Fehlt das Feld, wird der Test als
     "braucht Lanzetten" behandelt – die vorsichtigere Annahme. */
  function totalTestUnits(){
    return DATA.tests.reduce((s,t) => t.lancetsIncluded ? s : s + t.perBox * quantities[t.key], 0);
  }

  function requiredLancetBoxes(){
    const total = totalTestUnits();
    return total === 0 ? 0 : Math.ceil(total / DATA.lancet.perBox);
  }

  function autoSuggestLancets(){
    if(!lancetManuallySet) quantities['lancet'] = requiredLancetBoxes();
    refreshLancetDisplay();
  }

  function refreshLancetDisplay(){
    const qty = quantities['lancet'];
    document.getElementById('gcr-qty-lancet').textContent = qty;
    const totalEl = document.getElementById('gcr-total-lancet');
    if(qty > 0){
      totalEl.textContent = fmt(DATA.lancet.price * qty);
      totalEl.classList.remove('zero');
    } else {
      totalEl.textContent = fmt(DATA.lancet.price);
      totalEl.classList.add('zero');
    }
    document.getElementById('gcr-lancet-meta').textContent = (qty * DATA.lancet.perBox) + ' Stk. gesamt';

    /* Warnung, wenn die gewaehlte Lanzettenzahl den Bedarf nicht deckt.
       Das Element gab es im Markup schon, wurde aber nie angesprochen. */
    const warning = document.getElementById('gcr-lancet-warning');
    if(warning) warning.classList.toggle('show', (qty * DATA.lancet.perBox) < totalTestUnits());
  }

  function adjLancet(delta){
    lancetManuallySet = true;
    quantities['lancet'] = Math.max(0, quantities['lancet'] + delta);
    refreshLancetDisplay();
    updateAll();
  }

  function discountQty(){
    return DATA.tests.reduce((s,t) => s + quantities[t.key], 0);
  }
  function getDiscountRate(qty){
    if(APO) return qty >= APO.minBoxes ? APO.rate / 100 : 0;
    if(qty >= DATA.tierBoxes10) return DATA.tierRate10 / 100;
    if(qty >= DATA.tierBoxes5) return DATA.tierRate5 / 100;
    return 0;
  }

  function updateAll(){
    const testsSubtotal = DATA.tests.reduce((s,t) => s + t.price * quantities[t.key], 0);
    const lancetSubtotal = DATA.lancet.price * quantities['lancet'];

    const qty = discountQty();
    const rate = getDiscountRate(qty);
    const discountAmount = testsSubtotal * rate;
    const subtotal = testsSubtotal + lancetSubtotal;
    const total = subtotal - discountAmount;

    const label = APO ? `${Math.round(rate*100)}% Aposanitas-Rabatt Testboxen` : `${Math.round(rate*100)}% Mengenrabatt`;
    const breakdown = document.getElementById('gcr-total-breakdown');
    if(rate > 0){
      breakdown.innerHTML = `
        <div class="subtotal-row"><span>Zwischensumme</span><span>${fmt(subtotal)}</span></div>
        <div class="discount-row"><span>${label}</span><span>−${fmt(discountAmount)}</span></div>
        <div class="total-row">
          <span class="tlabel">Gesamt (netto)</span>
          <span class="tprice" id="gcr-grand-total">${fmt(total)}</span>
        </div>`;
    } else {
      breakdown.innerHTML = `
        <div class="total-row">
          <span class="tlabel">Gesamt (netto)</span>
          <span class="tprice" id="gcr-grand-total">${fmt(total)}</span>
        </div>`;
    }

    const block = document.getElementById('gcr-discount-block');
    const title = document.getElementById('gcr-discount-title');
    const amt   = document.getElementById('gcr-discount-amount');
    const sub   = document.getElementById('gcr-discount-sub');
    const fill  = document.getElementById('gcr-discount-fill');

    /* Aposanitas: eine Stufe, Darstellung wie im Aposanitas-Neukundenrechner */
    if(APO){
      const speedNote = APO.speed ? ' (Speed-Prämie bis 31. Oktober)' : '';
      amt.textContent = APO.rate + '%';
      fill.style.width = Math.min(100, (qty / APO.minBoxes) * 100) + '%';
      if(qty >= APO.minBoxes){
        block.className = 'voucher-block active';
        title.textContent = qty + (qty === 1 ? ' Testbox' : ' Testboxen');
        sub.textContent = `${APO.rate}% Rabatt auf alle ausgewählten Testboxen freigeschaltet${speedNote}.`;
      } else {
        block.className = 'voucher-block pending';
        title.textContent = qty + ' / ' + APO.minBoxes + ' Testboxen';
        const missing = APO.minBoxes - qty;
        sub.textContent = missing + (missing === 1 ? ' Testbox fehlt' : ' Testboxen fehlen') + ` bis zu ${APO.rate}% Rabatt auf Ihre Testboxen${speedNote}.`;
      }
      return;
    }

    amt.textContent = Math.round(rate * 100) + '%';

    if(qty >= DATA.tierBoxes10){
      block.className = 'voucher-block active';
      title.textContent = qty + ' Testboxen';
      sub.textContent = `Maximaler Mengenrabatt von ${DATA.tierRate10}% freigeschaltet.`;
      fill.style.width = '100%';
    } else if(qty >= DATA.tierBoxes5){
      block.className = 'voucher-block active';
      title.textContent = qty + ' Testboxen';
      const missing = DATA.tierBoxes10 - qty;
      sub.textContent = missing + (missing === 1 ? ' Testbox fehlt' : ' Testboxen fehlen') + ` bis zu ${DATA.tierRate10}% Mengenrabatt.`;
      fill.style.width = Math.min(100, ((qty - DATA.tierBoxes5) / (DATA.tierBoxes10 - DATA.tierBoxes5)) * 100) + '%';
    } else {
      block.className = 'voucher-block pending';
      title.textContent = qty + ' Testboxen';
      const missing = DATA.tierBoxes5 - qty;
      sub.textContent = missing + (missing === 1 ? ' Testbox fehlt' : ' Testboxen fehlen') + ` bis zu ${DATA.tierRate5}% Mengenrabatt.`;
      fill.style.width = Math.min(100, (qty / DATA.tierBoxes5) * 100) + '%';
    }
  }

  async function submitNachbestellung(){
    const btn = document.getElementById('gcr-order-btn');
    const hasSelection = discountQty() > 0 || quantities['lancet'] > 0;
    if(!hasSelection){
      alert('Bitte wählen Sie mindestens ein Testkit oder Lanzetten aus.');
      return;
    }

    const items = [];
    DATA.tests.forEach(t => { if(quantities[t.key] > 0) items.push({ id: t.variantId, quantity: quantities[t.key] }); });
    if(quantities['lancet'] > 0) items.push({ id: DATA.lancet.variantId, quantity: quantities['lancet'] });

    if(items.some(i => !i.id)){
      alert('Es sind noch nicht alle Produkte im Theme-Editor mit echten Shopify-Produkten verknüpft.');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';
    const result = await gcAddItemsToCart(items);
    btn.disabled = false;
    btn.textContent = 'In den Warenkorb legen';
    if(result) window.location.href = window.Shopify.routes.root + 'cart';
  }

  buildRows();
  autoSuggestLancets();
  updateAll();
  document.getElementById('gcr-lancet-minus').addEventListener('click', () => adjLancet(-1));
  document.getElementById('gcr-lancet-plus').addEventListener('click', () => adjLancet(1));
  document.getElementById('gcr-order-btn').addEventListener('click', submitNachbestellung);
})();
